import React = require("react");
import {InputHTMLAttributes} from "react";
import {Display} from "../../Display";
import "./VeboxLoginInput.scss"


export const VeboxLoginInput: React.FC<InputHTMLAttributes<HTMLInputElement>> = (props) => {
    const [showPassword, setShowPassword] = React.useState<boolean>(false);

    const showPwd = () => {
        return (val) => {
            setShowPassword(!showPassword);
        }
    }

    return (
        <>
            <Display isVisible={props.type === "password"}>
                <div className={"passwordMainContainer"}>
                    <div className="passwordFieldContainer">
                        <input
                            className={"loginInputField passwordInputField " + props.className}
                            name={props.name}
                            type={showPassword ? "type" : "password"}
                            placeholder={props.placeholder}
                            onChange={props.onChange}
                            value={props.value}
                            disabled={props.disabled}
                        />
                        <div className={"password-input-container"}>
                            <Display isVisible={!showPassword}>
                                    <span
                                        className="material-icons show-password-icon"
                                        onClick={showPwd()}
                                    >visibility</span>
                            </Display>
                            <Display isVisible={showPassword}>
                                    <span
                                        className="material-icons show-password-icon"
                                        onClick={showPwd()}
                                    >visibility_off</span>
                            </Display>
                        </div>
                    </div>
                </div>
            </Display>
            <Display isVisible={props.type !== "password"}>
                <input
                    className={"loginInputField " + props.className}
                    name={props.name}
                    type={props.type}
                    placeholder={props.placeholder}
                    onChange={props.onChange}
                    value={props.value}
                    disabled={props.disabled}
                />
            </Display>
        </>
    )
}